<p-panel>
  <ng-template #header>
    <div class="flex grow flex-row items-center gap-2">
      <span class="font-bold">{{ 'functions.ecg' | translate }}</span>
      <div class="justify-end-safe flex grow flex-row items-center gap-2">
        <p-selectbutton [options]="modeOptions" [(ngModel)]="mode" optionValue="value" (onOptionClick)=onModeSelection()>
          <ng-template #item let-item>
            <i [class]="item.icon"></i>
          </ng-template>
        </p-selectbutton>

        <p-button icon="pi pi-search-plus" size="small" (click)="onZoomIn()" />
        <p-button icon="pi pi-search-minus" size="small" (click)="onZoomOut()" />
        <p-button icon="pi pi-expand" size="small" (click)="onZoomReset()" />
      </div>
    </div>
  </ng-template>

  @if (loading) {
  <div class="me-3 mt-3">
    <div class="d-flex align-items-center">
      <strong>{{ 'loading' | translate }}</strong>
      <p-progress-spinner class="ms-auto" aria-label="Loading" [style]="{ width: '5rem', height: '5rem' }" />
    </div>
  </div>
  } @else {
  <div class="flex flex-col gap-1">
    @if(showInfo) {
    <span class="font-semibold text-red-600">{{ 'messages.maxData' | translate }}</span>
    }
    <p-chart #chart type="line" [data]="data" [options]="options" [plugins]="plugins" />
  </div>
  }

</p-panel>
